import { getCancellationReasonOptions } from '@acorn-portal/shared/src/pages/cancellation/utils/form-dropdowns/reason-form-dropdowns/get-cancellation-reason-options';
import CancellationReasonSchema from '@acorn-portal/shared/src/pages/cancellation/validation/cancellation-reason-schema';
import { ROUTE_PATHS } from '@acorn-portal/shared/src/utils/Routes';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { useAppSelector } from '../../hooks/reduxHook';
import { getPhoneNumber } from '../../utils/get-phone-numbers';
import CancellationReasonForm, { CancellationReasonFormValues } from './components/form/cancellation-reason-form';
import Heading from './components/heading';
import LeaveModal from './components/modal/journey-switch/leave-modal';
import ContentWrapper from './components/wrapper/content-wrapper';
import PageWrapper from './components/wrapper/page-wrapper';
import { useLeaveCancellation } from './hooks/use-leave-cancellation';
import { useReasonSubmission } from './hooks/use-reason-submission';
import useTrack from '@acorn-portal/shared/src/hooks/useTrack/useTrack';

const CancellationReason = () => {
	const navigate = useNavigate();
	const cancellationState = useAppSelector((state) => state.cancellation);
	const product = useAppSelector((state) => state.fullPolicy.product);
	const { handleLeaveCancellation, isLeaving } = useLeaveCancellation();
	const { handleSubmit } = useReasonSubmission();
	const { track } = useTrack();
	const [leaveModalOpen, setLeaveModalOpen] = useState(false);
	const contactNumber = getPhoneNumber(product, 'CONTACT');
	const dropdownOptions = { reason: getCancellationReasonOptions() };

	const initialValues: CancellationReasonFormValues = {
		reason: cancellationState.reasonForCancellation, // extract this if more form input added
	};

	useEffect(() => {
		track('cancellation_step_1_started', { name: 'cancellation_reason_page' });
	}, []);

	const onSubmit = (values: CancellationReasonFormValues) => {
		track('cancellation_reason_submitted', { reason: values.reason, step_number: 1 });
		handleSubmit(values);
	};

	const onBack = (journeyStarted: boolean) => {
		track('cancellation_reason_back_button', { journeyStarted, step_number: 1 });
		if (journeyStarted) setLeaveModalOpen(true);
		else navigate(ROUTE_PATHS.home);
	};

	const onLeave = (journeyStarted: boolean) => {
		track('cancellation_reason_leave_button', { journeyStarted, step_number: 1 });
		handleLeaveCancellation();
	};

	return (
		<PageWrapper>
			<ContentWrapper>
				<Heading>Reason for cancelling</Heading>
				<CancellationReasonForm
					initialValues={initialValues}
					validationSchema={CancellationReasonSchema}
					dropdowns={dropdownOptions}
					handleSubmit={onSubmit}
					handleBack={onBack}
					contactNumber={contactNumber}
				/>
			</ContentWrapper>
			<LeaveModal
				open={leaveModalOpen}
				onClose={() => setLeaveModalOpen(false)}
				onLeave={() => onLeave(true)}
				isLeaving={isLeaving}
				stepNumber={1}
			/>
		</PageWrapper>
	);
};

export default CancellationReason;
